import React, { useEffect } from 'react';
import BranchInquiry from './Inquiry/BranchInquiry';
import StoreInquiry from './Inquiry/StoreInquiry';
import RiderInquiry from './Inquiry/RiderInquiry';
import OtherInquiry from './Inquiry/OtherInquiry';
import style from '../css/inquiry.module.css'
import { useNavigate, useParams } from 'react-router-dom';



const Inquiry = () => {


  const { category } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!category) {
      navigate('/inquiry/1'); // 기본 경로로 리디렉션
    }
  }, [category, navigate]);

  const handleInquiryClick = (inquiry) => {
    navigate(`/inquiry/${inquiry}`);
  };

  return (
    <div>

      <div id={style.sub_top_warp}>
        <div className={style.sub_top}>
          <p className={style.sub_top_text01} >문의하기</p>
          <p className={style.sub_top_text02}>
            가맹점주님과 라이더님의 문의를 <br />
            항시 기다리고 있습니다.
          </p>
        </div>
      </div>


      <div id={style.sub_con_warp}>
        <div className={style.sub_menu}>
          <div
            className={style.sub_menu_pad}
            style={{ background: category === '1' ? "#000" : "#fff", color: category === '1' ? "#fff" : "#000" }}
            onClick={() => handleInquiryClick('1')}
          >
            지점 개설 문의
          </div>
          <div
            className={style.sub_menu_pad}
            style={{ background: category === '2' ? "#000" : "#fff", color: category === '2' ? "#fff" : "#000" }}
            onClick={() => handleInquiryClick('2')}
          >
            상점 문의
          </div>
          <div
            className={style.sub_menu_pad}
            style={{ background: category === '3' ? "#000" : "#fff", color: category === '3' ? "#fff" : "#000" }}
            onClick={() => handleInquiryClick('3')}
          >
            라이더 문의
          </div>
          <div
            className={style.sub_menu_pad}
            style={{ background: category === '4' ? "#000" : "#fff", color: category === '4' ? "#fff" : "#000" }}
            onClick={() => handleInquiryClick('4')}
          >
            기타 제휴 문의
          </div>
        </div>

        <div className={style.sub_title} >
          {category === '1' && <p className={style.sub_title_text01} >지점 개설 문의</p>}
          {category === '2' && <p className={style.sub_title_text01}>상점 문의</p>}
          {category === '3' && <p className={style.sub_title_text01}>라이더 문의</p>}
          {category === '4' && <p className={style.sub_title_text01}>기타 제휴 문의</p>}
        </div>

        {category === '1' && <BranchInquiry />}
        {category === '2' && <StoreInquiry />}
        {category === '3' && <RiderInquiry />}
        {category === '4' && <OtherInquiry />}

      </div>
      <div style={{ clear: 'both', height: 80 }}></div>
    </div>
  );
}

export default Inquiry;
